<script>
import baseList from "@/views/components/base/baseList.vue";
import { Button } from "view-design";
import AddMeeting from "./operate/addMeeting1.vue";
import SignIn from "./operate/signIn.vue";
export default {
  extends: baseList,
  components: { AddMeeting },
  data() {
    return {
      table: {
        mname: "",
        key: "id",
        url: {
          list: ``,
        },
        output: false,
      },
      menus: [
        {
          label: "我的会议",
          name: "MyMeeting",
          auth: "system/MyMeeting/index",
        },
        {
          label: "所有会议",
          name: "MeetingList",
          auth: "system/MeetingList/index",
        },
      ],
      actions: [{ label: "预定会议", onClick: this.toAdd, type: "info" }],
      filters: [
        {
          label: "开始时间",
          KeyEnter: this.search,
          name: "meetingStateTime",
          value: "",
          type: "contractdatetimerange",
        },
        {
          label: "会议室",
          KeyEnter: this.search,
          name: "meetingLocationName",
          value: "",
          type: "input",
        },
        {
          label: "主题",
          KeyEnter: this.search,
          name: "meetingtTitle",
          value: "",
          type: "input",
        },
      ],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "主题/参会人",
          minWidth: 350,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            let names;
            let userList = row.sysUserList;
            if (userList) {
              names = userList.map((obj) => obj.nickName).join(", ");
            }
            return (
              <div>
                <p
                  style={{ color: "blue", cursor: "pointer" }}
                  onClick={() => this.toClaim(row)}
                >
                  {row.meetingtTitle}
                </p>
                <p>参会人: {names}</p>
              </div>
            );
          },
        },
        {
          title: "会议室",
          minWidth: 80,
          align: "left",
          key: "meetingLocationName",
        },
        {
          title: "开始时间",
          width: 160,
          align: "left",
          key: "meetingStateTime",
        },
        {
          title: "时长",
          width: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row.meetingDuration;
            const text =
              row == "1"
                ? "30分钟"
                : row === "2"
                  ? "1小时"
                  : row === "3"
                    ? "1.5小时"
                    : row === "4"
                      ? "2小时"
                      : row === "5"
                        ? "2.5小时"
                        : row === "6"
                          ? "3小时"
                          : row === "7"
                            ? "3.5小时"
                            : row === "8"
                              ? "4小时"
                              : row === "9"
                                ? "4.5小时"
                                : row === "10"
                                  ? "5小时"
                                  : row === "11"
                                    ? "5.5小时"
                                    : row === "12"
                                      ? "6小时"
                                      : row === "13"
                                        ? "6.5小时"
                                        : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "签到时间",
          width: 140,
          align: "center",
          render: (h, params) => {
            const row = params.row.meetingCheckDuration;
            const text =
              row == "1"
                ? "开始前15分钟"
                : row === "2"
                  ? "开始前20分钟"
                  : row === "3"
                    ? "开始前30分钟"
                    : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "状态",
          width: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row.type;
            const text =
              row == 1
                ? "未开始"
                : row === 2
                  ? "签到中"
                  : row === 3
                    ? "进行中"
                    : row === 4
                      ? "已结束"
                      : row === 5
                        ? "审核中"
                        : row === 6
                          ? "审核拒绝"
                          : row === 7
                            ? "已取消"
                            : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "拒绝理由",
          minWidth: 50,
          align: "center",
          key: "rejectContent",
        },
        {
          title: "备注",
          minWidth: 50,
          align: "center",
          key: "remark",
        },
        {
          title: "操作",
          align: "center",
          width: 180,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              return (
                <div>
                  <Button
                    size="small"
                    vShow={currentRow.type == 7 ? false : true}
                    onClick={() => this.cancel(currentRow)}
                    type="default"
                    style={{
                      border: "none",
                      color: "#4991ff",
                      marginRight: "5px",
                    }}
                  >
                    取消
                  </Button>
                  <Button
                    size="small"
                    onClick={() => this.delItem(currentRow)}
                    type="default"
                    style={{
                      border: "none",
                      color: "#4991ff",
                      marginRight: "5px",
                    }}
                  >
                    删除
                  </Button>
                  <Button
                    vShow={currentRow.type == 7 || currentRow.type == 6 ? false : true}
                    size="small"
                    onClick={() => this.onItemInfo(currentRow)}
                    type="default"
                    style={{
                      border: "none",
                      color: "#4991ff",
                    }}
                  >
                    编辑
                  </Button>
                  <Button
                    size="small"
                    vShow={
                      currentRow.type == 5 || currentRow.type == 6 || currentRow.type == 7
                        ? false
                        : true
                    }
                    onClick={() => this.tominute(currentRow)}
                    type="default"
                    style={{
                      border: "none",
                      color: "#4991ff",
                      marginTop: "5px",
                      marginRight: "5px",
                    }}
                  >
                    写记录
                  </Button>
                  <Button
                    vShow={
                      currentRow.type == 5 || currentRow.type == 6 || currentRow.type == 7
                        ? false
                        : true
                    }
                    size="small"
                    onClick={() => this.toInfo(currentRow)}
                    type="default"
                    style={{
                      border: "none",
                      color: "#4991ff",
                      marginTop: "5px",
                    }}
                  >
                    会议记录
                  </Button>
                </div>
              );
            },
          ],
        },
      ],
    };
  },
  created() {
    let Id = JSON.parse(window.localStorage.getItem("authuid")).data;
    this.table.url.list = `/admin/system/meeting/list?meetingIsFinish=1&principalId=${Id}`;
  },
  methods: {
    toInfo(Row) {
      $utils.url.push({ name: "meetingInfo", query: { id: Row.meetingId } });
    },
    onCancel() {
      this.$Modal.remove();
      this.search();
    },
    cancel(row) {
      this.$Modal.success({
        title: "确认是否要取消当前会议?",
        showOk: false,
        closable: true,
        width: "500px",
        render: (h) => {
          return (
            <div style="width:100%;display:flex;justify-content:center; ">
              <Button
                type="primary"
                onClick={() => {
                  this.oncancel(row);
                }}
              >
                确定
              </Button>
            </div>
          );
        },
      });
    },
    toAdd() {
      this.$Modal.success({
        closable: true,
        width: "800px",
        height: "80px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <div>
              <AddMeeting
                onOnCancel={() => {
                  this.onCancel();
                }}
                action="add"
              />
            </div>
          );
        },
      });
    },
    toClaim(Row) {
      $utils.api.load(`/admin/system/meeting/${Row.meetingId}`, {}).then((res) => {
        if (res && res.data) {
          let type = res.data.type;
          if (type == 5) {
            $utils.toast.success("会议审核中,请稍后!");
          } else if (type == 7) {
            $utils.toast.success("会议已取消!");
          } else {
            this.$Modal.success({
              closable: true,
              width: "1300px",
              height: "80px",
              okText: "取消",
              showOk: false,
              render: (h) => {
                return (
                  <div>
                    <SignIn
                      onOnCancel={() => {
                        this.onCancel();
                      }}
                      id={Row.meetingId}
                    />
                  </div>
                );
              },
            });
          }
        }
      });
    },
    tominute(Row) {
      $utils.url.push({ name: "minute", query: { id: Row.meetingId } });
    },
    onItemInfo(row) {
      this.$Modal.success({
        closable: true,
        width: "800px",
        height: "80px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <div>
              <AddMeeting
                onOnCancel={() => {
                  this.onCancel();
                }}
                actions="edit"
                ids={row.meetingId}
              />
            </div>
          );
        },
      });
    },
    async delItem(row) {
      let d = {};
      let res = await $utils.api.load(
        `/admin/system/meeting/${row.meetingId}`,
        d,
        "DELETE"
      );
      if (res.code == 200) {
        $utils.toast.success("删除成功！");
        setTimeout(() => {
          this.onCancel();
        }, 100);
      }
    },
    async oncancel(row) {
      let d = { meetingId: row.meetingId };
      $utils.api
        .load(`/admin/system/meeting/moveMeeting`, d, "POST")
        .then((res) => {
          this.$Modal.remove();
          $utils.toast.success("成功！");
          this.search();
        })
        .catch((e) => {
          this.sloading = false;
          $utils.toast.error("保存异常" + e.message);
        });
    },
  },
};
</script>

<style></style>
